import { Clickable, Icon } from 'components';
import styled from 'styled-components';

const CustomArrows = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    display: none;
  }
`;

const Arrows = ({ elem, amount = 700, col = 'black' }) => {
  function handleScroll(direction) {
    const scrollPos = elem.current.scrollLeft;

    elem.current.scroll({
      left:
        direction === 'left'
          ? scrollPos - amount < amount
            ? 0
            : scrollPos - amount
          : scrollPos + amount,
      behavior: 'smooth'
    });
  }

  return (
    <CustomArrows>
      <Clickable marg="0 12px 0 0" onClick={() => handleScroll('left')}>
        <Icon type="arrowLeftLong" col={col} dimensions={30} />
      </Clickable>

      <Clickable onClick={() => handleScroll('right')}>
        <Icon type="arrowRightLong" col={col} dimensions={30} />
      </Clickable>
    </CustomArrows>
  );
};

export default Arrows;
